interface TitleParams {
  presentTags: Array<Tag>;
  maxOffSetWidth: number;
  maxRow: number;
  moreBtnWidth: number;
}
interface Tag {
  clientWidth: number;
  innerText?: string;
}
export const getVisibleTagsCount = (params: TitleParams) => {
  const { presentTags, maxOffSetWidth, maxRow, moreBtnWidth } = params;
  let allowedChilds = 0;
  let currentRow = 1;
  let tagIndex = presentTags.length;
  for (let index = 0; index < presentTags.length; index++) {
    // temporary fix to adjust the font swap adjustments. Multiply by 1.11
    allowedChilds = allowedChilds + presentTags[index].clientWidth * 1.11;
    if (currentRow != maxRow && allowedChilds > maxOffSetWidth) {
      allowedChilds = presentTags[index].clientWidth;
      currentRow++;
    }
    if (
      allowedChilds + moreBtnWidth > maxOffSetWidth &&
      currentRow === maxRow
    ) {
      tagIndex = index;
      break;
    }
  }
  return tagIndex;
};
